(function () {
  var CUSTOM = 'Custom Size';
  function money(c) { return '$' + (Number(c) / 100).toFixed(2); }
  function optionValues(v) { return [v.option1, v.option2, v.option3]; }
  function byId(vs, id) { id = parseInt(id, 10); for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i]; return null; }
  function fitIndex(vs) { for (var i = 0; i < vs.length; i++) { var o = optionValues(vs[i]); for (var j = 0; j < o.length; j++) if (o[j] === CUSTOM) return j; } return -1; }
  function matchCustom(vs, fi, ref) { if (fi === -1) return null; var r = optionValues(ref); for (var i = 0; i < vs.length; i++) { var o = optionValues(vs[i]), ok = true; for (var j = 0; j < 3; j++) { if (j === fi) continue; if (o[j] !== r[j]) { ok = false; break; } } if (ok && o[fi] === CUSTOM) return vs[i]; } return null; }
  var JACKET = [{ key: 'chest', label: 'Chest (in)' }, { key: 'shoulder', label: 'Shoulder (in)' }, { key: 'sleeve', label: 'Sleeve Length (in)' }, { key: 'length', label: 'Jacket Length (in)' }];
  var SKIRT = [{ key: 'waist', label: 'Waist (in)' }, { key: 'hip', label: 'Hip (in)' }, { key: 'length', label: 'Skirt Length (in)' }];
  var VEST = [{ key: 'chest', label: 'Chest (in)' }, { key: 'waist', label: 'Waist (in)' }, { key: 'shoulder', label: 'Shoulder Width (in)' }, { key: 'length', label: 'Vest Length (in)' }];

  function getForm(block) {
    var f = document.getElementById(block.getAttribute('data-form-id'));
    return f || document.querySelector('form[action*="/cart/add"]');
  }
  function selectedVariantId(form) {
    if (!form) return null;
    var h = form.querySelector('input[name="id"]');
    return h ? h.value : null;
  }

  function init(block) {
    if (block.__bespokeInit) return;
    block.__bespokeInit = true;
    var uid = block.getAttribute('data-bespoke-uid');
    var modal = document.querySelector('.bespoke-modal[data-bespoke-uid="' + uid + '"]');
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var vs = JSON.parse(block.querySelector('[data-bespoke-variants]').textContent || '[]');
    var fi = fitIndex(vs);
    var header = block.querySelector('[data-bespoke-header]');
    var openBtn = block.querySelector('[data-bespoke-open]');
    var openLabel = openBtn.textContent;
    var closeBtn = modal.querySelector('[data-bespoke-close]');
    var submitBtn = modal.querySelector('[data-bespoke-submit]');
    var errorEl = modal.querySelector('[data-bespoke-error]');
    var priceEl = block.querySelector('[data-bespoke-price]');
    var summaryEl = block.querySelector('[data-bespoke-summary]');
    var footerEl = modal.querySelector('[data-bespoke-footer]');
    var badge = block.querySelector('[data-bespoke-selected-badge]');
    var propKey = uid;

    function form() { return getForm(block); }
    function current() { var id = selectedVariantId(form()); return id ? byId(vs, id) : null; }
    function customSelected() { var c = current(); return !!(c && fi !== -1 && optionValues(c)[fi] === CUSTOM); }
    function hasSaved() { return !!document.querySelector('[data-bespoke-property="' + propKey + '"]'); }

    function updateSelected() {
      var s = customSelected();
      block.classList.toggle('is-selected', s);
      if (badge) badge.hidden = !s;
      openBtn.classList.toggle('is-selected', s);
      openBtn.setAttribute('aria-pressed', s ? 'true' : 'false');
      openBtn.textContent = s ? '✓ Custom Size Selected — Edit Details' : openLabel;
    }
    function refreshPrice() { var c = current(); if (!c || !priceEl) return; var cv = matchCustom(vs, fi, c); priceEl.textContent = money(cv ? cv.price : c.price); }
    function expand() { if (block.classList.contains('is-active')) return; block.classList.add('is-active'); header.setAttribute('aria-expanded', 'true'); }
    function pickCustomVariant() {
      if (customSelected()) return;
      var r = document.querySelector('variant-picker input[type="radio"][data-option-name="Fit Type"][value="' + CUSTOM + '"]');
      if (r && !r.checked) r.click();
    }
    function toggle() { var a = block.classList.toggle('is-active'); header.setAttribute('aria-expanded', a ? 'true' : 'false'); refreshPrice(); updateSelected(); }
    header.addEventListener('click', toggle);
    header.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    function openModal() { refreshPrice(); updateSelected(); expand(); modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function closeModal() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

    var tabs = modal.querySelectorAll('[data-bespoke-tab]');
    var panes = modal.querySelectorAll('[data-bespoke-pane]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var n = tab.getAttribute('data-bespoke-tab');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panes.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        modal.querySelector('[data-bespoke-pane="' + n + '"]').classList.add('is-active');
        if (footerEl) footerEl.style.display = n === 'consult' ? 'none' : '';
      });
    });
    modal.querySelectorAll('[data-measure-target]').forEach(function (input) {
      var line = modal.querySelector('.bespoke-measure-line[data-measure="' + input.getAttribute('data-measure-target') + '"]');
      if (!line) return;
      input.addEventListener('focus', function () { line.classList.add('is-active'); });
      input.addEventListener('blur', function () { line.classList.remove('is-active'); });
    });
    function showError(m) { errorEl.textContent = m; errorEl.classList.add('is-visible'); }
    function clearError() { errorEl.textContent = ''; errorEl.classList.remove('is-visible'); }
    function activeTab() { var t = modal.querySelector('.bespoke-tab.is-active'); return t ? t.getAttribute('data-bespoke-tab') : 'measure'; }
    function measureFields() {
      var kind = modal.getAttribute('data-bespoke-form');
      if (kind === 'vest') return VEST;
      if (kind === 'skirt') return SKIRT;
      if (kind === 'jacket') return JACKET;
      return modal.querySelector('[data-bespoke-field="waist"]') ? SKIRT : JACKET;
    }
    function collect() {
      var mode = activeTab();
      var props = { 'Custom Size': 'Yes', 'Estimated Ship Time': '2-3 weeks' };
      if (mode === 'consult') { props['Fit Method'] = 'Consultation Requested'; return { properties: props }; }
      props['Fit Method'] = mode === 'measure' ? 'Exact Measurements' : 'Standard Size + Adjustments';
      if (mode === 'measure') {
        var fields = measureFields();
        var values = {}, missing = null;
        fields.forEach(function (f) { var el = modal.querySelector('[data-bespoke-field="' + f.key + '"]'); var v = el ? el.value : ''; values[f.key] = v; if (!v && !missing) missing = f.key; });
        if (missing) return { error: 'Please provide all measurements, or switch to "Adjust My Usual Size."', field: missing };
        fields.forEach(function (f) { props[f.label] = values[f.key]; });
        props['Fit Preference'] = modal.querySelector('[data-bespoke-field="preference"]').value;
      } else {
        var ref = modal.querySelector('[data-bespoke-field="refsize"]').value;
        var notes = modal.querySelector('[data-bespoke-field="notes"]').value;
        if (!notes || notes.trim().length < 3) return { error: 'Please describe at least one adjustment, or switch to "Provide My Measurements."', field: 'notes' };
        props['Reference Size'] = ref; props['Adjustment Notes'] = notes.trim();
      }
      return { properties: props };
    }
    function clearProps() { document.querySelectorAll('[data-bespoke-property="' + propKey + '"]').forEach(function (el) { el.remove(); }); }
    function syncProps(props) {
      clearProps();
      var f = form(); if (!props || !f) return;
      var fid = f.getAttribute('id');
      Object.keys(props).forEach(function (k) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = props[k];
        if (fid) i.setAttribute('form', fid);
        i.setAttribute('data-bespoke-property', propKey);
        document.body.appendChild(i);
      });
    }
    function renderSummary(props) {
      var lines = [];
      Object.keys(props).forEach(function (k) { if (k === 'Custom Size') return; lines.push('<strong>' + k + ':</strong> ' + props[k]); });
      summaryEl.innerHTML = '✓ Fit confirmed, ' + lines.join(' &middot; ');
      summaryEl.hidden = false;
    }
    submitBtn.addEventListener('click', function () {
      if (activeTab() === 'consult') { closeModal(); return; }
      clearError();
      var r = collect();
      if (r.error) { showError(r.error); var el = modal.querySelector('[data-bespoke-field="' + r.field + '"]'); if (el) el.focus(); return; }
      pickCustomVariant();
      syncProps(r.properties);
      renderSummary(r.properties);
      updateSelected();
      closeModal();
    });

    /* Only drop saved fit details when the shopper switches Fit Type back to Standard.
       Changing size or colour while Custom Size is selected keeps them. */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('variant-picker input[type="radio"]')) return;
      var isFit = t.getAttribute('data-option-name') === 'Fit Type';
      setTimeout(function () {
        refreshPrice(); updateSelected();
        if (customSelected()) { expand(); }
        else if (isFit && t.value !== CUSTOM) { clearProps(); summaryEl.hidden = true; }
      }, 250);
    });

    /* Block add-to-cart (button click OR form submit) when Custom Size is selected without saved fit details */
    function guard(e) {
      if (!customSelected() || hasSaved()) return;
      e.preventDefault(); e.stopImmediatePropagation(); expand(); openModal();
    }
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var btn = t.closest('add-to-cart-component, [name="add"], form[action*="/cart/add"] button[type="submit"], .sticky-add-to-cart button');
      if (btn) guard(e);
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) guard(e);
    }, true);

    refreshPrice(); updateSelected();
  }

  var scanTimer = null;
  function scan() { document.querySelectorAll('[data-bespoke]').forEach(init); }
  function scheduleScan() { clearTimeout(scanTimer); scanTimer = setTimeout(scan, 100); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });
})();
